import { ArrowPathIcon as RefreshIcon } from "@heroicons/react/24/outline";
import { format } from "date-fns";
import { ReportSummaryApi } from "../api/Reports";
import { classNames } from "../utils";

interface LoadedSinceProps {
  timestamp: number | undefined;
}
interface IProps {
  reportData: LoadedSinceProps | ReportSummaryApi | undefined;
  onClear: () => void;
  className?: string;
}

export const LoadedSince = ({ reportData, onClear, className }: IProps) => {
  if (reportData && reportData.timestamp) {
    return (
      <div className={classNames(className ?? "absolute right-2 -top-[30px]")}>
        <small>
          <div className="mr-2 flex items-center gap-2">
            <RefreshIcon
              className="text-green-600 w-5 cursor-pointer"
              onClick={onClear}
            />
            <span>Last Updated {format(reportData.timestamp, "hh:mm a")}</span>
          </div>
        </small>
      </div>
    );
  }
  return <></>;
};
